import { useWindQuoteAndIxs, useLoopscaleWalletContext } from "@bridgesplit/abf-react";
import { percentUiToDecimals } from "@bridgesplit/utils";
import { DEFAULT_SLIPPAGE } from "app/components/common";

import { UseIncreaseLeverageQuoteReturn, UseIncreaseLeverageQuoteParams } from "./types";

export function useIncreaseLeverageQuote({
    loopPosition,
    loanExpanded,
    increasePrincipalAmount,
    slippagePercentDecimals,
    skip = false
}: UseIncreaseLeverageQuoteParams): UseIncreaseLeverageQuoteReturn {
    const {
        data: { userWalletAddress: userWallet }
    } = useLoopscaleWalletContext();

    // Increase leverage quote - uses user input to determine amount of principal to borrow
    const {
        data: increaseLeverageQuote,
        isLoading: increaseLeverageQuoteLoading,
        isFetching: increaseLeverageQuoteIsFetching,
        error: increaseLeverageQuoteError
    } = useWindQuoteAndIxs({
        principalUsdPrice: loanExpanded?.principalUsdPrice,
        userWallet,
        loopExpanded: loopPosition?.loopExpanded,
        principalAmount: increasePrincipalAmount,
        windMint: loopPosition?.loopExpanded?.principalToken.mint,
        slippagePercentDecimals: slippagePercentDecimals ?? percentUiToDecimals(DEFAULT_SLIPPAGE),
        inputAmount: 0,
        clmmPosition: undefined,
        skip: skip || slippagePercentDecimals === undefined || !increasePrincipalAmount
    });

    return {
        increaseLeverageQuote,
        increaseLeverageQuoteLoading: increaseLeverageQuoteLoading,
        increaseLeverageQuoteFetching: increaseLeverageQuoteIsFetching,
        increaseLeverageQuoteError:
            !increaseLeverageQuoteLoading && !increaseLeverageQuoteIsFetching ? increaseLeverageQuoteError : undefined,
        validHealthIncreaseLeverageQuote: true
    };
}
